import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import menu from './modules/menu'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    menuList: [],
    fromList: [],
    holidays: [
      { month: 1, date: 2, name: '新年' },
      { month: 1, date: 3, name: '新年' },
      { month: 1, date: 1, name: '元日' },
      { month: 2, date: 11, name: '建国記念の日' },
      { month: 2, date: 23, name: '天皇誕生日' },
      { month: 3, date: 21, name: '春分の日' },
      { month: 4, date: 29, name: '昭和の日' },
      { month: 5, date: 3, name: '憲法記念日' },
      { month: 5, date: 4, name: 'みどりの日' },
      { month: 5, date: 5, name: 'こどもの日' },
      { month: 7, date: 18, name: '海の日' },
      { month: 8, date: 11, name: '山の日' },
      { month: 9, date: 19, name: '敬老の日' },
      { month: 9, date: 23, name: '秋分の日' },
      { month: 10, date: 10, name: 'スポーツの日' },
      { month: 11, date: 3, name: '文化の日' },
      { month: 11, date: 23, name: '勤労感謝の日' },
      { month: 12, date: 29, name: '新年' },
      { month: 12, date: 30, name: '新年' },
      { month: 12, date: 31, name: '新年' }
    ]
  },
  getters: {
  },
  mutations: {
    update (state, data) {
      state.menuList = data
    },
    fromStore (state, data) {
      state.fromList = data
    },
    holidays (state, data) {

    }
  },
  actions: {
  },
  modules: {
    menu
  },
  getters
})